import * as React from "react";
import { InfoCircleOutlined } from "@ant-design/icons";
import { Input, Popover, Typography } from "antd";
const { Text } = Typography;

interface InputFieldProps {
  maxLength: number;
  title?: string;
  text?: React.ReactNode;
  initialValue?: string;
  disabled?: boolean;
  type?: "text" | "number" | "email";
  onChange?: (value: string) => void;
  error?: string;
}

export default function InputField({
  maxLength,
  title = "",
  text,
  initialValue = "",
  type = "text",
  onChange,
  disabled,
  error,
}: InputFieldProps) {
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    if (onChange) {
      onChange(newValue); // Pass updated value to parent
    }
  };

  const hasTitle = title && title.trim() !== "";

  return (
    <div className={hasTitle ? "flex gap-1" : ""}>
      {hasTitle && <label className={"mr-4  whitespace-nowrap w-[240px] text-start"}>{title}</label>}

      <div className={`flex items-center ${hasTitle ? "w-[65%]" : "w-full"}`}>
        <div className={`flex items-center ${hasTitle ? "w-[60%]" : "w-full"} relative overflow-hidden`}>
          <Input
            className="whitespace-nowrap w-full"
            maxLength={maxLength}
            disabled={disabled}
            value={initialValue}
            onChange={handleInputChange}
            type={type}
            status={error ? "error" : undefined}
            addonAfter={
              text ? (
                <div className={" bg-[#f5f5f5] h-full w-full"}>
                  <Popover content={text} trigger="click" overlayStyle={{ width: 400 }}>
                    <InfoCircleOutlined style={{ cursor: "pointer" }} />
                  </Popover>
                </div>
              ) : undefined
            }
          />

          {error && <Text type="danger">{error}</Text>}
        </div>
      </div>
    </div>
  );
}
